<template>
  <el-form
    :label-position="labelPosition"
    :label-width="labelWidthFilter"
    :model="model"
    :rules="rules"
    @submit.native.prevent="doFilter"
    class="filter"
    ref="form"
  >
    <el-row :gutter="16" class="filter__container"> 

      <!-- School Name -->
      <el-col :lg="20" :md="16" :sm="24">
        <el-form-item :prop="fields.name.name">
          <div class="form__item__label__slot" slot="label">
            <span>{{fields.name.label}}</span>
            <el-button
              v-if="model.name"
              type="text"
              @click="resetFieldFilter({ fieldKey: 'name'})"
            >
              <app-i18n code="common.reset"/>
            </el-button>
          </div>
          <el-input
            clearable
            prefix-icon="icon-teams"
            :placeholder="fields.name.label"
            v-model="model[fields.name.name]"
            @input.native="debounceInput"
            @clear="doFilter"
          />
        </el-form-item>
      </el-col>

      <!-- School location -->
      <!-- <el-col :lg="8" :md="16" :sm="24">
        <el-form-item :prop="fields.location.name">
          <div class="form__item__label__slot" slot="label">
            <span>{{fields.location.label}}</span>
            <el-button
              v-if="model.location"
              type="text"
              @click="resetFieldFilter({ fieldKey: 'location'})"
            >
              <app-i18n code="common.reset"/>
            </el-button>
          </div>
          <el-input
            clearable
            prefix-icon="icon-location"
            :placeholder="fields.location.label"
            v-model="model[fields.location.name]"
            @input.native="debounceInput"
            @clear="doFilter"
          />
        </el-form-item>
      </el-col> -->

      <!-- School managers -->
      <!-- <el-col :lg="8" :md="16" :sm="24">
        <el-form-item :prop="fields.coaches.name">
          <div class="form__item__label__slot" slot="label">
            <span>{{fields.coaches.label}}</span>
            <el-button
              v-if="model.coaches"
              type="text"
              @click="resetFieldFilter({ fieldKey: 'coaches'})"
            >
              <app-i18n code="common.reset"/>
            </el-button>
          </div>
          <el-input
            clearable
            prefix-icon="icon-player"
            :placeholder="fields.coaches.label"
            v-model="model[fields.coaches.name]"
            @input.native="debounceInput"
            @clear="doFilter"
          />
        </el-form-item>
      </el-col> -->

      <!-- Reset button -->
      <el-col :lg="4" :md="16" :sm="24">
        <div class="filter-buttons">
          <el-button
            :disabled="loading"
            @click="doResetFilter"
            icon="icon-undo"
            circle
          />
        </div>
      </el-col>
    </el-row>
  </el-form>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { FilterSchema } from '@shared/form/filter-schema';
import { SchoolModel } from '@modules/school/school-model';
import _ from 'lodash';
//import { get } from 'lodash';

const { fields } = SchoolModel;

const filterSchema = new FilterSchema([
  fields.name,
  // fields.location,
  // fields.coaches,
]);

export default {
  name: 'app-school-list-filter',

  data() {
    return {
      rules: filterSchema.rules(),
      model: {},
    };
  },

  computed: {
    ...mapGetters({
      labelPosition: 'layout/labelPosition',
      labelWidthFilter: 'layout/labelWidthFilter',
      loading: 'school/list/loading',
      filter: 'school/list/filter',
    }),

    fields() {
      return fields;
    },
  },

  async mounted() {
    this.model = filterSchema.initialValues(
      this.filter,
      this.$route.query,
    );

    //return this.doFilter();
  },

  methods: {
    ...mapActions({
      doReset: 'school/list/doReset',
      doFetch: 'school/list/doFetch',
    }),

    async doResetFilter() {
      this.model = filterSchema.initialValues();
      this.$refs.form.clearValidate();
      return this.doReset();
    },

    async resetFieldFilter({ fieldKey }) {
      if (this.model[`${fieldKey}`]) this.model[`${fieldKey}`] = null;
      this.doFilter();
    },

    debounceInput: _.debounce(function () {
      this.doFilter();
    }, 500),

    async doFilter() {
      try {
        await this.$refs.form.validate();
        this.$refs.form.clearValidate();
      } catch (error) {
        return;
      }

      const filter = filterSchema.cast(this.model);
      return this.doFetch({
        filter,
      });
      //return this.doFetch();
    },
  },
};
</script>

<style>
</style>
